import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: 'cart',
  initialState: { items: [] },
  reducers: {
    setItems: (state, action) => {
      return {
        ...state,
        items: [...action.payload]
      }
    },
    addItem: (state, action) => {
      let existingItemIndex = state.items.findIndex((i) => {
        if (i.id === action.payload.id) {
          const customizations = i.customizations;
          const _customizations = action.payload.customizations;
          if (!customizations && !_customizations) {
            return true;
          }
          if (customizations.length === _customizations.length) {
            customizations.sort(
              (prev, curr) => prev.customizationId - curr.customizationId
            );
            _customizations.sort(
              (prev, curr) => prev.customizationId - curr.customizationId
            );
            return customizations.every(
              (c, i) =>
                c.customizationId === _customizations[i].customizationId &&
                c.customizations
                  .sort((prev, curr) => prev.id - curr.id)
                  .every(
                    (p, x) =>
                      p.id ===
                      _customizations[i].customizations.sort(
                        (prev, curr) => prev.id - curr.id
                      )[x].id
                  )
            );
          }
        }
        return false;
      });

      if (existingItemIndex !== -1) {
        state.items[existingItemIndex].quantity += action.payload.quantity;
      } else {
        action.payload.quantity = action.payload.quantity || 1;
        state.items = [...state.items, action.payload];
      }
    },
    removeItem: (state, action) => {
      let item = state.items[action.payload.index];
      item.quantity = Math.max(item.quantity - action.payload.quantity, 0);
      if (item.quantity === 0) {
        state.items = [
          ...state.items.slice(0, action.payload.index),
          ...state.items.slice(action.payload.index + 1),
        ];
      }
    },
    updateItemQty: (state, action) => {
      state.items[action.payload.index].quantity = action.payload.quantity;
    },
    empty: (state) => ({ ...state, items: [] })
  },
  selectors: {
    selectItems: (state) => state.items
  }
})

export default cartSlice.reducer;

export const { selectItems } = cartSlice.selectors;
export const { addItem, removeItem, updateItemQty, empty, setItems } = cartSlice.actions;